import { render, staticRenderFns } from "./JournalItem.vue?vue&type=template&id=20ceeea2&scoped=true&"
import script from "./JournalItem.vue?vue&type=script&lang=js&"
export * from "./JournalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ceeea2",
  null
  
)

export default component.exports